import { RenderParcelCardProps } from "entities/shared/parcelCard.types";
import { RenderParcelSearchErrorCardProps } from "entities/shared/parcelCard.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

import { ParcelSearchCardModel } from "../model/model";

type ParcelSearchCardProps = {
  data: ParcelSearchCardModel;
  shipmentType: ValueOf<typeof ShipmentType>;
  className?: string;
  openCard: (data: ParcelSearchCardModel) => void;
  deleteCardHandler: (card: ParcelSearchCardModel) => void;
  renderCard: (props: RenderParcelCardProps) => JSX.Element;
  renderErrorCard: (props: RenderParcelSearchErrorCardProps) => JSX.Element;
};

export const ParcelSearchCard: RFC<ParcelSearchCardProps> = ({
  data,
  shipmentType,
  openCard,
  deleteCardHandler,
  renderCard,
  renderErrorCard,
}) => {
  const onDeleteHandler = () => deleteCardHandler(data);

  const onOpenHandler = () => {
    openCard(data);
  };

  const errorText = "";

  if (errorText) {
    return renderErrorCard({
      text: errorText,
      status: "error",
      reference: data.reference,
      onDelete: onDeleteHandler,
    });
  }

  return renderCard({
    shipmentType,
    ata: data.ata,
    atd: data.atd,
    eta: data.eta,
    etd: data.etd,
    reference: data.reference,
    status: data.status,
    carrierName: data.carrierName,
    scac: data.carrierCode,
    directionFrom: data.fromDirection,
    directionTo: data.toDirection,
    progressLine: { status: "location-data", percent: data.progress, rotation: "horizontal" },
    onOpen: onOpenHandler,
    onDelete: onDeleteHandler,
  });
};
